import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=5e613768&"
import script from "./CheckboxItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports